import { Tooltipß } from '@otter-ai/den-components';
import { LockFilledIcon } from '@otter-ai/den-icons';
import type { OtterPlanType } from '@/shared/types/plan';
import { getUpgradeDetails } from '@/shared/utils/planUtils';
import { useSubscription } from '../../shared/hooks/useSubscription';

type PaywallTooltipProps = {
  size?: number;
};

export function PaywallTooltip(props: PaywallTooltipProps) {
  const { size = 20 } = props;
  const { subscription } = useSubscription();

  return (
    <Tooltipß
      caption={`${
        getUpgradeDetails(subscription?.plan_type as OtterPlanType).name
      } feature`}
    >
      <div>
        <LockFilledIcon className="text-primary ml-1" size={size} />
      </div>
    </Tooltipß>
  );
}
